import { createInjectionKey as o } from "../../_utils/vue/create-injection-key.js";
const n = o("n-config-provider");
export {
  n as configProviderInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/config-provider/src/context.js
// module id = 128
// module chunks = 67